<template>
  <div class="quick-entry" :class="{marginTop: margin}">
    <Card style="border-top: 1px solid #e9eaec;" :dis-hover="true" :bordered="false">
      <p slot="title"><Icon :type="icon" size="15"></Icon> {{title}}</p>
      <div class="entry-wrapper">
        <div class="entry-item" v-for="(entry,index) in list" :key="index" @click="viewModal(entry)" :title="entry.tips">
          <Badge :count="entry.count">
            <img :src="'/img/icons/'+entry.title+'.png'" :width="size" :height="size">
            <h5 style="margin-top: 10px;white-space: nowrap">{{entry.title}}</h5>
          </Badge>
        </div>
        <div class="blank" v-show="list.length === 0">
          <Icon type="android-sad" size="40" style="margin-right: 6px"></Icon>
          暂无相关数据
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import { formatDate } from '@/lib/tool'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'

export default {
  props: {
    icon: String,
    size: String,
    title: String,
    list: Array,
    margin: Boolean
  },
  methods: {
    viewModal(entry) {
      this.$emit('viewModal', entry)
    }
  }
}
</script>

<style lang='less' scoped>
.demo-badge{
  width: 42px;
  height: 42px;
  background: #eee;
  border-radius: 6px;
  display: inline-block;
}
/deep/.ivu-badge-count {
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0;
  top: -6px;
}
.quick-entry {
  /deep/.ivu-card-body {
    padding: 0;
  }
  .entry-wrapper {
    .entry-item {
      display: inline-block;
      width: fit-content;
      min-width: 70px;
      padding: 0.6% 0px;
      margin: 4px;
      border-radius: 5px;
      text-align: center;
    }
    .entry-item:hover {
      background-color: rgba(92, 173, 255, 0.3);
      cursor: pointer;
    }
    .blank {
      display: flex;
      height: 64px;
      color: #ccc;
      justify-content: center;
      align-items: center;
    }
  }
}
.marginTop {
  margin-top: 5px;
}
</style>
